export default "__VITE_ASSET__a66e50fa__"